import { paths } from "../../../Routes";
import { ENV_IS_PROD } from "../../envVars";
import { THEME_NAMES } from "../../themes/config";
import { flowTest } from "../flowTest";
import { astaraFlow } from "./components/astara";
import { caixabankFlows } from "./components/caixabank";
import { contractFlows } from "./components/contract";
import { defaultFlows } from "./components/default";
import { ktuinFlows } from "./components/ktuin";
import { upfFlows } from "./components/upf";
import { videoIdFlows } from "./components/videoId";

export const getFlowCollection = (processState, authState, currentUrl) => {
  if (processState.flowTest && ENV_IS_PROD !== "true") {
    return flowTest;
  }

  if (currentUrl.includes(paths.VideoId)) {
    return videoIdFlows;
  }

  if (currentUrl.includes(paths.Contract)) {
    return contractFlows;
  }

  if (authState?.agent?.custom_theme === THEME_NAMES.caixabank) {
    return caixabankFlows;
  }

  if (authState?.agent?.custom_theme === THEME_NAMES.ktuin) {
    return ktuinFlows;
  }

  if (authState?.agent?.custom_theme === THEME_NAMES.upf) {
    return upfFlows;
  }

  if (authState?.agent?.custom_theme === THEME_NAMES.astara) {
    return astaraFlow;
  }

  return defaultFlows;
};
